import React, { forwardRef } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";
import { LocalizationProvider, LicenseInfo } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import "./dateRangePicker.css";
import { fieldToTextField } from "formik-material-ui";

LicenseInfo.setLicenseKey(
  "b3797b650a3bd36f98c3dc7a00e5f266Tz00OTk4NyxFPTE2OTM0NzQ3NDQ4NzQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);

const DateRangePickerFormik = forwardRef(
  ({ value, onChange, fieldValue, textFieldProps, size, ...props }) => {
    const theme = useTheme();
    const {
      form: { setTouched, setFieldValue, touched },
    } = props;
    const { error, helperText, ...field } = fieldToTextField(props);
    const { name } = field;
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateRangePicker
          inputFormat="YYYY-MM-DD"
          {...props}
          {...field}
          value={value}
          onChange={(value) => {
            setFieldValue(name, value);
          }}
          onBlur={() => setTouched({ ...touched, [name]: true })}
          renderInput={(startProps, endProps) => (
            <React.Fragment>
              <TextField
                {...startProps}
                helperText={helperText}
                error={error}
                placeholder={textFieldProps.startPlaceHolder}
                label=""
                size="small"
                sx={{
                  ".MuiOutlinedInput-root": {
                    outline: `1px ${theme.palette.borderColor.textField}`,
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: "8px",
                  },
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
              />
              <Box sx={{ mx: 0.5 }}> to </Box>
              <TextField
                {...endProps}
                helperText={helperText}
                placeholder={textFieldProps.endPlaceHolder}
                error={error}
                label=""
                size="small"
                sx={{
                  ".MuiOutlinedInput-root": {
                    outline: `1px ${theme.palette.borderColor.textField}`,
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: "8px",
                  },
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
              />
            </React.Fragment>
          )}
        />
      </LocalizationProvider>
    );
  }
);

export default DateRangePickerFormik;
